import Vue from "vue";

export default Vue.extend({
  activated() {
    this.__refresh();
  },
  methods: {
    __refresh() {
      console.log("refresh");
      requestAnimationFrame(() => {
        if (this.$refs.scroll) {
          this.$refs.scroll.refresh();
        } else {
          this.__refresh();
        }
      });
    }
  }
});
